import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  mapRequestedServiceErrorTitle: {
    description: 'mapRequestedServiceStore.mapRequestedServiceErrorTitle',
    defaultMessage: 'Service Mapping Error',
    id: 'NqkPYI',
  },
  mapRequestedServiceErrorMessage: {
    description: 'mapRequestedServiceStore.mapRequestedServiceErrorMessage',
    defaultMessage: 'Service could not be mapped at this time. Please try again.',
    id: 'Sl6kYw',
  },
  mapRequestedServiceTitle: {
    description: 'mapRequestedServiceModal.title',
    defaultMessage: 'Map Requested Service',
    id: 'w3OCtm',
  },
  mapRequestedServiceServiceLabel: {
    description: 'mapRequestedServiceModal.serviceName',
    defaultMessage: 'Map requested service, {requestedServiceCode} to:',
    id: 'vZ7u7C',
  },
  mapRequestedServiceInstructionOne: {
    description: 'mapRequestedServiceModal.instructions1',
    defaultMessage:
      'Mapping the Requested Service to a Shipping Service and Package (optional) will automatically assign that service when the Order is imported.',
    id: 'dcYyLw',
  },
  mapRequestedServiceInstructionTwo: {
    description: 'mapRequestedServiceModal.instructions2',
    defaultMessage: 'Note that this is saved per-store, and will only apply to this store {storeName}',
    id: 'GI/kga',
  },
  mapRequestedServiceSaveMapping: {
    description: 'mapRequestedServiceModal.saveMapping',
    defaultMessage: 'Save Mapping',
    id: 'LA/fVm',
  },
});
